/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBillingEntryCleanup extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBillingEntryCleanup");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBillingEntryCleanup.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBillingEntryCleanup>): BackgroundJobPayloadForBillingEntryCleanup {
        let obj = Object.assign(new BackgroundJobPayloadForBillingEntryCleanup(), model);
        BackgroundJobPayloadForBillingEntryCleanup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBillingEntryCleanup>): BackgroundJobPayloadForBillingEntryCleanup {
        if (!model) return null;
        return BackgroundJobPayloadForBillingEntryCleanup.newInstance(<BackgroundJobPayloadForBillingEntryCleanup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBillingEntryCleanup) {
        if (!obj) return;

        models.BackgroundJobPayloadForBillingEntryCleanup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBillingEntryCleanup): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBillingEntryCleanup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Target Cloud Account
     */
    service_account_id: string;

}
